import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { SecundarioPage } from '@/features/cadastro-secundario/page/SecundarioPage';

const SecundarioSearchSchema = z.union([
    z.object({
        tab1: z.literal('geral'),
        tab2: z.enum(['marcadores', 'eventos']),
    }),
    z.object({
        tab1: z.literal('venda'),
        tab2: z.enum(['tabela-preco', 'tabela-comissao']),
    }),
    z.object({
        tab1: z.literal('financeiro'),
        tab2: z.enum([
            'formas-pagamento',
            'condicoes-pagamento',
            'contas-bancarias',
            'contas-caixa',
            'categoria-despesa',
            'categoria-receita',
        ]),
    }),
    z.object({
        tab1: z.literal('cliente'),
        tab2: z.literal('ramo-atividade'),
    }),
    z.object({
        idpk: z.string().optional(),
        mode: z.enum(['cadastrar', 'editar']).optional(),
        tab1: z.literal('produto'),
        tab2: z.literal('adicional'),
    }),
    z.object({
        tab1: z.literal('produto'),
        tab2: z.enum(['categoria', 'marca', 'variacao', 'local-estoque']),
    }),
    z.object({
        tab1: z.literal('colaborador'),
        tab2: z.enum(['vendedor', 'entregador']),
    }),
]);

export type SecundarioSearch = z.infer<typeof SecundarioSearchSchema>;

export const Route = createFileRoute('/a/secundario/')({
    component: Component,
    validateSearch: SecundarioSearchSchema,
});

function Component() {
    const search = Route.useSearch();

    return <SecundarioPage {...search} />;
}
